export type IkasPaymentGatewaySettings = {
  label: string;
  order: number;
  type: IkasPaymentGatewaySettingsType;
  value: string | null;
};

export enum IkasPaymentGatewaySettingsType {
  NUMBER = "NUMBER",
  PASSWORD = "PASSWORD",
  TEXT = "TEXT",
}
